import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  MenuItem,
  Select,
  FormControl,
  styled,
  tableCellClasses,
  Box,
  useMediaQuery,
  Tooltip,
} from "@mui/material";
import { getUrl } from "src/Utils/Common";
import FacebookCircularProgress from "src/Components/shared/shared/Loading";
import { theme } from "../../../Theme/index";
import { useSelector } from "react-redux";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    padding: "4px", // Further reduce padding
    color: "#4A4A4A",
    fontSize: "10px", // Make text smaller on mobile
    fontWeight: "bold",
    textAlign: "center",
    backgroundColor: "#f9f9f9",
    whiteSpace: "nowrap", // Prevents header wrapping issues
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "10px",
    textAlign: "center",
    padding: "3px", // Adjust for mobile
    borderBottom: "none",
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  height: 35,
}));

const Badge = styled(Box)(({ value }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "4px 12px",
  borderRadius: "12px",
  fontSize: "10px",
  fontWeight: "bold",
  backgroundColor: "#FFFFFF", // Always white background
  border: `2px solid ${value < 0 ? "#CD393B" : "#08306B"}`, // Red border if negative, Blue if positive
  color: value < 0 ? "#CD393B" : "#08306B", // Red text if negative, Blue if positive
  minWidth: "28px",
  maxWidth: "50px",
  textAlign: "center",
  flexWrap: "wrap",
  wordBreak: "break-word",
  overflow: "hidden",
}));

function MarketComparisonTableTop5Brands({Top5Manufacturer, type, timePeriod}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [comparisonType, setComparisonType] = useState("P12M");
  const projectId = useSelector((state) => state.userProject.projectId);
  const selectedFilter = useSelector((state) => state.filter.selectedFilter); // ✅ Get Redux filter
  const isMobile = useMediaQuery("(max-width: 600px)"); // Detects mobile screens
  const currentChartType = useSelector((state) => state.chart.currentChartType);

  const getApiFilters = () => {
    if (!selectedFilter || selectedFilter.length === 0) return {};

    return selectedFilter.reduce((acc, item) => {
      const { category, name } = item;

      if (!acc[category]) {
        acc[category] = []; // Initialize category array if not exists
      }

      acc[category].push(name); // Push the name value
      return acc;
    }, {});
  };
  const formatNumber = (num) => {
    console.log(num)
    if (num >= 1e6) return (num / 1e6).toFixed(2) + 'M';
    if (num >= 1e3) return (num / 1e3).toFixed(2) + 'K';
    return num?.toString() ?? '';
    };

  useEffect(() => {
    if(Top5Manufacturer && Object.keys(Top5Manufacturer).length > 0){
        console.log(Top5Manufacturer)
        setLoading(true);
    if(type === "Manufacturer"){
    const transformedData = Top5Manufacturer.manufacturer.map((manufacturer, index) => ({
        manufacturer,
        year: Top5Manufacturer.year[index],
        Time_Granularity: Top5Manufacturer.Time_Granularity[index],
        value_sales: formatNumber(Top5Manufacturer.value_sales[index]),
        volume_sales: formatNumber(Top5Manufacturer.volume_sales[index]),
        price_index: Top5Manufacturer.price_index[index],
        Value_Sales_Growth: Top5Manufacturer.Value_Sales_Growth[index],
        Volume_Sales_Growth: Top5Manufacturer.Volume_Sales_Growth[index],
        Price_Index_Growth: Top5Manufacturer.Price_Index_Growth[index],
        Value_Share: Top5Manufacturer.Value_Share[index],
        Volume_Share: Top5Manufacturer.Volume_Share[index],
        Value_Share_Growth: Top5Manufacturer.Value_Share_Growth[index],
        Volume_Share_Growth: Top5Manufacturer.Volume_Share_Growth[index]
        }));
    console.log(transformedData)
    setData(transformedData)
    setLoading(false)
    }
    else{
        const transformedData = Top5Manufacturer.brand.map((brand, index) => ({
        brand,
        year: Top5Manufacturer.year[index],
        Time_Granularity: Top5Manufacturer.Time_Granularity[index],
        value_sales: formatNumber(Top5Manufacturer.value_sales[index]),
        volume_sales: formatNumber(Top5Manufacturer.volume_sales[index]),
        price_index: Top5Manufacturer.price_index[index],
        Value_Sales_Growth: Top5Manufacturer.Value_Sales_Growth[index],
        Volume_Sales_Growth: Top5Manufacturer.Volume_Sales_Growth[index],
        Price_Index_Growth: Top5Manufacturer.Price_Index_Growth[index],
        Value_Share: Top5Manufacturer.Value_Share[index],
        Volume_Share: Top5Manufacturer.Volume_Share[index],
        Value_Share_Growth: Top5Manufacturer.Value_Share_Growth[index],
        Volume_Share_Growth: Top5Manufacturer.Volume_Share_Growth[index]
    }));
    console.log(transformedData)
    setData(transformedData)
    setLoading(false)
    }
    }
  }, [Top5Manufacturer, type, timePeriod]);

  if (loading) {
    return <FacebookCircularProgress />;
  }

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }
  return (
    <>
      
      <Box sx={{ padding: "3px", backgroundColor: "#fff" }}>
        {/* Make Table Responsive */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100vw",
            overflowX: "auto",
            display: "block",
            padding: "10px",
          }}
        >
            <Typography>
                Top 5 {type}
            </Typography>
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: "10px",
              width: "100%",
              overflowX: "auto",
              maxWidth: "100%",
              display: "block",
              whiteSpace: "nowrap",
              WebkitOverflowScrolling: "touch",
            }}
          >
            <Table stickyHeader aria-label="market comparison table" sx={{ minWidth: isMobile ? 550 : "100%" }}>
              {isMobile ? (
                <TableHead>
                  <TableRow>
                    <StyledTableCell sx={{ textAlign: "left", minWidth: 90 }}>{type}</StyledTableCell>
                    <StyledTableCell sx={{ textAlign: "center", minWidth: 90 }}>Value Sales (SAR)</StyledTableCell>
                    <StyledTableCell sx={{ textAlign: "center", minWidth: 75 }}>
                      <Tooltip title="Growth in value sales vs last year" arrow>Growth (%)</Tooltip>
                    </StyledTableCell>
                    <StyledTableCell sx={{ textAlign: "center", minWidth: 90 }}>Volume Sales (Ton)</StyledTableCell>
                    <StyledTableCell sx={{ textAlign: "center", minWidth: 75 }}>
                      <Tooltip title="Growth in volume sales vs last year" arrow>Growth (%)</Tooltip>
                    </StyledTableCell>
                    <StyledTableCell sx={{ textAlign: "center", minWidth: 85 }}>
                      <Tooltip title="Price index vs last year" arrow>Price Index (YA)</Tooltip>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
              ) : (
                <TableHead>
                  <TableRow>
                    <StyledTableCell></StyledTableCell>
                    <StyledTableCell>Value Sales (SAR)</StyledTableCell>
                    <StyledTableCell>
                      <Tooltip title="Growth in values sales compared to last year" arrow>
                            Growth (%)
                        </Tooltip>
                    </StyledTableCell>
                    <StyledTableCell>Volume Sales (Ton)</StyledTableCell>
                    <StyledTableCell>
                        <Tooltip title="Growth in volume sales compared to last yeaer" arrow>
                            Growth (%)
                        </Tooltip>
                      </StyledTableCell>
                    <StyledTableCell>
                      <Tooltip title="Average price compared to last year" arrow>
                         Price Index (YA)
                      </Tooltip>
                      </StyledTableCell>
                  </TableRow>
                </TableHead>
              )}
              <TableBody>
                {isMobile ? (
                  // Mobile Layout - full columns with horizontal scroll
                  <>
                    {data && data.length > 0 ? (
                      data.map((item, idx) => (
                        <StyledTableRow key={idx}>
                          <StyledTableCell
                            sx={{
                              fontWeight: "bold",
                              color: "#08306B",
                              textAlign: "left",
                              whiteSpace: "nowrap",
                              minWidth: 90,
                              backgroundColor: "#f9f9f9",
                            }}
                          >
                            {item[type.toLowerCase()]}
                          </StyledTableCell>
                          <StyledTableCell sx={{ minWidth: 90 }}>
                            <Badge value={0}>{item.value_sales}</Badge>
                          </StyledTableCell>
                          <StyledTableCell sx={{ minWidth: 75 }}>
                            <Badge value={item.Value_Sales_Growth ?? 0}>
                              {typeof item.Value_Sales_Growth === "number"
                                ? item.Value_Sales_Growth.toFixed(2)
                                : item.Value_Sales_Growth}
                            </Badge>
                          </StyledTableCell>
                          <StyledTableCell sx={{ minWidth: 90 }}>
                            <Badge value={0}>{item.volume_sales}</Badge>
                          </StyledTableCell>
                          <StyledTableCell sx={{ minWidth: 75 }}>
                            <Badge value={item.Volume_Sales_Growth ?? 0}>
                              {typeof item.Volume_Sales_Growth === "number"
                                ? item.Volume_Sales_Growth.toFixed(2)
                                : item.Volume_Sales_Growth}
                            </Badge>
                          </StyledTableCell>
                          <StyledTableCell sx={{ minWidth: 85 }}>
                            <Badge value={item.Price_Index_Growth ?? 0}>
                              {typeof item.Price_Index_Growth === "number"
                                ? item.Price_Index_Growth.toFixed(2)
                                : item.Price_Index_Growth}
                            </Badge>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell colSpan={6} sx={{ textAlign: "center", py: 2 }}>
                          No data
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </>
                ) : (
                  // Desktop Layout - Column Headers
                  <>
                    
                        {data.map((item, idx) => {
                          return (
                            <StyledTableRow key={idx}>
                            <StyledTableCell
                                sx={{
                                    fontWeight: "bold",
                                    color: "#08306B",
                                    textAlign: "left",
                                    whiteSpace: "nowrap",
                                    minWidth: 120,
                                }}
                                >
                                {item[type.toLowerCase()]}
                            </StyledTableCell>
                            <StyledTableCell>
                              <Badge value={item.value_sales}>{item.value_sales}</Badge>
                            </StyledTableCell>
                            <StyledTableCell>
                              <Badge value={item.Value_Sales_Growth}>{item.Value_Sales_Growth.toFixed(2)}</Badge>
                            </StyledTableCell>
                            <StyledTableCell>
                              <Badge value={item.volume_sales}>{item.volume_sales}</Badge>
                            </StyledTableCell>
                            <StyledTableCell>
                              <Badge value={item.Volume_Sales_Growth}>{item.Volume_Sales_Growth.toFixed(2)}</Badge>
                            </StyledTableCell>
                            <StyledTableCell>
                              <Badge value={item.Price_Index_Growth}>{item.Price_Index_Growth.toFixed(2)}</Badge>
                            </StyledTableCell>
                            </StyledTableRow>

                          );
                        }
                    )}
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </>
  );
}

export default MarketComparisonTableTop5Brands;
